import React from "react";
import { useTranslation } from "react-i18next";
import { ModalHeader } from "reactstrap";

type Props = {
    onClose: () => void;
};

export default function AssociateModalHeader({ onClose }: Props) {
    const { t } = useTranslation();
    return (
        <ModalHeader className="text-capitalize" toggle={onClose}>
            <span
                className="text-uppercase fed_txt_AFloyaltyList"
                style={{
                    fontFamily: "Segoe UI Semibold",
                    color: "#2b2828",
                    fontSize: "20px",
                }}
            >
                {t("List of fidelity")}
            </span>
        </ModalHeader>
    );
}
